import axios from '@/axios/axios'
import _ from 'lodash'

//const KAKAO_REDIRECT_URI = "http://localhost:8081/auth/join"
const KAKAO_REDIRECT_URI = 'http://newagingplatform-b2c.co.kr/auth/join'

export default {
  namespaced: true,
  state: {
    kakaoIds: '',
    currentTab: 0,
    type: '',
    termsService: false,
    termsPrivacy: false,
    signupForm: {},
    completedInfo: {
      id: '',
      name: '',
      phoneNumber: '',
      email: '',
      company: '',
    },
  },
  mutations: {
    setKakaoId: (state, kakaoId) => (state.kakaoId = kakaoId),
    setCurrentTab: (state, currentTab) => (state.currentTab = currentTab),
    setTermsService: (state, termsService) => (state.termsService = termsService),
    setTermsPrivacy: (state, termsPrivacy) => (state.termsPrivacy = termsPrivacy),
    setType: (state, type) => (state.type = type),
    setCompletedInfo: (state, completedInfo) => (state.completedInfo = completedInfo),
    setSignupForm: (state, signupForm) => (state.signupForm = signupForm),
    concatSignupForm: (state, signupForm) =>
      (state.signupForm = _.assign(state.signupForm, signupForm)),
    resetState: (state) => {
      state.kakaoIds = ''
      state.currentTab = 0
      state.type = ''
      state.termsPrivacy = false
      state.termsService = false
      state.signupForm = {}
      state.completedInfo = { id: '', name: '', phoneNumber: '', email: '', company: '' }
    },
  },
  getters: {
    getKakaoRedirectUri: () => KAKAO_REDIRECT_URI,
    getKakaoId: (state) => state.kakaoId,
    getCurrentTab: (state) => state.currentTab,
    getTermsService: (state) => state.termsService,
    getTermsPrivacy: (state) => state.termsPrivacy,
    getType: (state) => state.type,
    getCompletedInfo: (state) => state.completedInfo,
    getSignupForm: (state) => state.signupForm,
  },
  actions: {
    requestKakaoInfo(context, code) {
      return axios
        .post('/api/auth/kakaoInfo', {
          code: code,
          redirectUri: KAKAO_REDIRECT_URI,
        })
        .then((response) => {
          return Promise.resolve(response)
        })
        .catch((error) => {
          console.log(error.response)
          return Promise.reject(error)
        })
    },
  },
}
